import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/store-config";
const API_PATH_STORE = ConstantList.API_EN_POINT_STORE ;

export const saveOrUpdateStoreConfig = storeConfig => axios.post(API_PATH + "/save-or-update", storeConfig);

export const getStoreConfigById = storeConfigId => axios.get(API_PATH + "/get-by-id/" + storeConfigId);

export const deleteStoreConfig = storeConfigId => axios.delete(API_PATH + "/mark-delete/" + storeConfigId);

export const pagingStoreConfig = searchStoreConfig => axios.post(API_PATH + "/search-by-page", searchStoreConfig);
//đồng bộ kho
export const getSyncStore = searchStoreConfig => axios.post(API_PATH + "/sync-store", searchStoreConfig);

//call api xuống kho
export const getSourceFromStores = searchStore => axios.post(API_PATH_STORE + "/store-source/pagingSources", searchStore);
export const getBiddingPackages = searchStore => axios.post(API_PATH_STORE + "/bidding-package/paging-bidding-package", searchStore);
export const getLots = searchStore => axios.post(API_PATH_STORE + "/bidding-package/lots", searchStore);


